const Footer = () => {
    return (
        <>
        <footer>
            <h6>This site was made with a dash of challenge, ample fun, and lots of learning!</h6>
        </footer>
        </>
    )
};

export default Footer;